import { Inject, Injectable } from '@angular/core'
import { Store } from '@ngrx/store'
import { selectConcernedViewAllConcerned } from '../../../../subject/state/concerned-view/concerned-view.selectors'
import { take } from 'rxjs/operators'

@Injectable({
    providedIn: 'root'
})
export class GeneralMapLayerDefinitionsDtsrcLpisService {

    // @ts-ignore
    private backendOptions = CA_CONFIG.BACKEND_OPTIONS

    constructor(
        @Inject(Store) private store: Store,
    ) {
    }

    public getLayerAllLpisFarmerBlocksOwn(): any {
        return {
            id: 'all-farmer-blocks-own',
            layer: {
                type: 'wms',
                url: this.getWmsLpisLayersUrlWithoutCache(),
                wms: {
                    layers: this.getLpisLayerPrefix() + 'lpis',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 88
                },
                filter: {
                    type: 'And',
                    args: [
                        {
                            type: 'PropertyIsNull',
                            propertyName: 'platnost_do'
                        }
                    ].concat(this.getAllLayerLpisFarmerBlockFilterCond(true))
                },
                sldBody: {
                    name: this.getLpisLayerPrefix() + 'lpis',
                    rules: [
                        {
                            name: 'all-farmer-blocks-own',
                            polygonSymbolizer: {
                                fill: {
                                    svgParameter: {
                                        'fill': '#eb9454',
                                        'fill-opacity': 0.55
                                    }
                                },
                                stroke: {
                                    svgParameter: {
                                        'stroke': '#6C3208',
                                        'stroke-width': 1
                                    }
                                }
                            }
                        }
                    ]
                }
            }
        }
    }

    public getLayerAllLpisFarmerBlocksForeign(): any {
        return {
            id: 'all-farmer-blocks-foreign',
            layer: {
                type: 'wms',
                url: this.getWmsLpisLayersUrlWithoutCache(),
                wms: {
                    layers: this.getLpisLayerPrefix() + 'lpis',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 88
                },
                filter: this.getAllLayerLpisFarmerBlocksForeignFilter(null),
                sldBody: {
                    name: this.getLpisLayerPrefix() + 'lpis',
                    rules: [
                        {
                            name: 'all-farmer-blocks-own',
                            polygonSymbolizer: {
                                fill: {
                                    svgParameter: {
                                        'fill': '#a0a0a0',
                                        'fill-opacity': 0.67
                                    }
                                },
                                stroke: {
                                    svgParameter: {
                                        'stroke': '#000000',
                                        'stroke-width': 1
                                    }
                                }
                            }
                        }
                    ]
                }
            }
        }
    }

    public getAllLayerLpisFarmerBlockFilterCond(isEqual): any {
        this.store.select(selectConcernedViewAllConcerned).pipe(take(1)).subscribe(allConcerned => {
            let cond = []
            allConcerned.forEach((concerned) => {
                let lpisId = concerned.lpisUserId

                if (lpisId) {
                    let oneCond

                    if (isEqual) {
                        oneCond = {
                            type: 'PropertyIsEqualTo',
                            propertyName: 'id_uz',
                            literal: lpisId
                        }
                    } else {
                        oneCond = {type: 'Not',
                            arg: {
                                type: 'PropertyIsEqualTo',
                                propertyName: 'id_uz',
                                literal: lpisId
                            }
                        }
                    }

                    cond.push(oneCond)
                }
            })

            return cond
        })
    }

    public getAllLayerLpisFarmerBlocksForeignFilter(lpisUzivatel): any {
        if (lpisUzivatel && lpisUzivatel.idUz) {
            return {
                type: 'And',
                args: [
                    {
                        type: 'PropertyIsEqualTo',
                        propertyName: 'id_uz',
                        literal: lpisUzivatel.userId
                    },
                    {
                        type: 'PropertyIsNull',
                        propertyName: 'platnost_do'
                    }
                ]
            }

        }

        return {
            type: 'And',
            args: [
                {
                    type: 'PropertyIsNull',
                    propertyName: 'platnost_do'
                }
            ].concat(this.getAllLayerLpisFarmerBlockFilterCond(false))
        }
    }

    private getLpisLayerPrefix(): string {
        return 'dtsrc_lpis:dtsrc_lpis_dtsrc_lpis_'
    }

    private getWmsLpisLayersUrlWithoutCache(): string {
        return this.backendOptions.geoserverLpisUrl + '/wms'
    }
}
